export default function decapitalize(str) {
    if (str.length === 0) {
        return str;
    }

    return str.charAt(0).toLowerCase() + str.slice(1);
}
